import React from 'react'
import { BasicLayers, FeatureCollectionLayers, GeojsonLayers, WMSLayers } from '@dataplace.ai/ui-components/atoms/MapTile/@types/LayersTypes'
import { IFeatureCollection } from '@dataplace.ai/ui-components/atoms/MapTile/components/MapOverlays/@types/IFeatureCollection'
import { IGeojson } from '@dataplace.ai/ui-components/atoms/MapTile/components/MapOverlays/@types/IGeojson'
import { ITile } from 'apps/placeme/src/features/Analyse/slice/@types/ITile'
import { renderToStaticMarkup } from 'react-dom/server'
import { useTranslation } from 'react-i18next'
import { getBrandMarker } from '@dataplace.ai/ui-components/atoms/KanbanMap/utils/functions'
import { WellFitCompetitionWithinRangeProps } from '../WellFitCompetitionWithinRange'
import { PopupContent, StyledPopupParagraph } from '../WellFitCompetitionWithinRange.styles'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function useGetLayers(data: WellFitCompetitionWithinRangeProps, tile: ITile | undefined) {
  const { t } = useTranslation()
  const rangeCoords = tile?.chosenRange?.geoJSON?.coordinates
  const features : IFeatureCollection['data']['features'] = []
  data?.value.competition.competitors?.map((point) => features.push({
    geometry: {
      coordinates: [point.lng, point.lat],
      type: 'Point',
    },
    properties: {
      popupContent: renderToStaticMarkup(
        <PopupContent>
          <StyledPopupParagraph>{`${t('generic.brand')}: ${point.brand}`}</StyledPopupParagraph>
          <StyledPopupParagraph>{`${t('generic.address')}: ${point.address}`}</StyledPopupParagraph>
          <StyledPopupParagraph>{`${t('generic.distance')}: ${Math.round(point.distance)}m`}</StyledPopupParagraph>
        </PopupContent>,
      ),
      pinnedItem: {
        iconAnchor:[11, 11],
        class: 'poi-img',
        html: `<img alt='' src='${point.logo || 'assets/icons/logoPlaceholder.svg'}' style="width:22px; height: 22px;"/>`,
      },
    },
    type: 'Feature',
  }))
  // eslint-disable-next-line array-callback-return
  data?.value.competition.own?.map((point) => {
    const icon = getBrandMarker({
      brand: null,
      status: point.status,
    }).options.html
    features.push({
      geometry: {
        coordinates: [point.lng, point.lat],
        type: 'Point',
      },
      properties: {
        popupContent: renderToStaticMarkup(
          <PopupContent>
            <StyledPopupParagraph>{`${t('generic.brand')}: ${point.brand}`}</StyledPopupParagraph>
            {!!point.name && <StyledPopupParagraph>{`${t('generic.name')}: ${point.name}`}</StyledPopupParagraph>}
            <StyledPopupParagraph>{`${t('generic.address')}: ${point.address}`}</StyledPopupParagraph>
            <StyledPopupParagraph>{`${t('generic.distance')}: ${Math.round(point.distance)}m`}</StyledPopupParagraph>
            <StyledPopupParagraph>
              {`${t('generic.status')}: `}
              {t(`chain.location.status.${point.status}`)}
            </StyledPopupParagraph>
            {!!point.siteId && <StyledPopupParagraph>{`${t('generic.site_id')}: ${point.siteId}`}</StyledPopupParagraph>}
          </PopupContent>,
        ),
        pinnedItem: {
          iconAnchor:[11, 11],
          class: 'poi-img',
          html: icon ? icon.toString() : '<img alt="" src="assets/icons/logoPlaceholder.svg" style="width:22px; height: 22px;"/>',
        },
      },
      type: 'Feature',
    })
  })

  const layers: (BasicLayers | GeojsonLayers | WMSLayers | FeatureCollectionLayers)[] = [
    {
      id: 'pois-layer',
      layer: {
        data: {
          features,
          type: 'FeatureCollection',
        },
        options: {
          type: 'geojson',
          id: 'pois',
        },
      },
    },
  ]
  if (rangeCoords) {
    layers.push({
      id: tile?.id || '',
      layer: {
        data: {
          coordinates: (rangeCoords) as IGeojson['data']['coordinates'],
          type: 'Polygon',
          properties: {},
        },
        options:{
          type: 'geojson',
          id: 'pois_range',
          style: {
            color: '#0000a2',
            fillColor:'#0000a2',
            weight: 1.5,
            fillOpacity: 0.05,
          },
        },
      },
    })
  }
  return layers
}

export default useGetLayers
